export default __webpack_public_path__ + "static/media/725.31820ccf.png";